<template>
  <!-- Main -->
  <div id="main">
    <!-- 合約 -->
    <div id="mainContract">
      <div class="areaH">
        <div class="areaV">
          <div class="box">
            <div class="item">
              <span class="title">合約</span>
              <!-- <a class="add" @click="showCreateContract()"
                ><FontAwesomeIcon icon="plus"
              /></a> -->
            </div>
            <!-- <div class="item">
              <EditBoxBoolean
                :code="'sys_closed'"
                :name="'啟用系統'"
                :value="settingData.sys_closed"
                :dbTable="'accounts'"
                :key="'sys_closed'"
                revert
                @toggle-switch="toggleSwitch($event)"
              />
            </div> -->
            <table>
              <tr>
                <th style="min-width: 30px;"><span class="content">#</span></th>
                <th><span class="content">方案</span></th>
                <th><span class="content">合約期限</span></th>
                <th><span class="content">系統截止日</span></th>
                <th><span class="content">合約訂單編號</span></th>
              </tr>
              <tr class="edit" v-show="createContractSatus">
                <td></td>
                <td align="center">
                  <div class="dropdown">
                    <select name="type" v-model="selectedPlan">
                      <option
                        v-for="plan in plans"
                        :key="plan.code"
                        :value="plan.code"
                        >{{ plan.plan }}</option
                      >
                    </select>
                    <div class="arrow">
                      <FontAwesomeIcon icon="caret-down" />
                    </div>
                  </div>
                </td>
                <td align="center">
                  <div class="dateRange">
                    <input type="date" v-model="selectedPlanStart" />
                    <span class="content">-</span>
                    <input type="date" v-model="selectedPlanEnd" />
                  </div>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td align="center">
                  <div class="action">
                    <a @click="addContract()"><FontAwesomeIcon icon="save"/></a>
                    <a @click="hideCreateContract()"
                      ><FontAwesomeIcon icon="times"
                    /></a>
                  </div>
                </td>
              </tr>
              <tr
                v-for="(contract, index) in contracts"
                :key="'contract' + index"
              >
                <td align="center">
                  <span class="content">{{ index + 1 }}</span>
                </td>
                <td align="center">
                  <span class="content">{{ contract.displayName }}</span>
                </td>
                <td align="center">
                  <span class="content"
                    >{{ displayContractStart(contract.start) }} -
                    {{ displayContractEnd(contract.end) }}</span
                  >
                </td>
                <td align="center">
                  <span class="content">{{
                    displaySystemEnd(contract.sysEnd)
                  }}</span>
                </td>
                <td align="center">
                  <span class="content">{{
                    contract.registrationOrderId
                  }}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fetchContract } from "src/javascripts/gaa/fetchForConsoleLog";
import { createContract, enable, disable } from "src/javascripts/gaa/postData";
import moment from "moment-timezone";
import { fetchPlans, fetchShopInfoByAccountId } from "src/javascripts/gaa/fetchData";
import EditBoxBoolean from "src/components/GaaConsole/EditBoxBoolean.vue";
import { fetchSettings } from "src/javascripts/gaa/fetchForConsoleLog";
import {
  updateAccounts,
  updateBusiness,
  updateBusinessInfo,
  updateAccountSSo
} from "src/javascripts/gaa/updateForConsoleLog";

export default {
  components: {
    FontAwesomeIcon,
    EditBoxBoolean
  },
  data() {
    return {
      settingData: {
        sys_closed: true
      },
      registrationOrders: [],
      busninessId: 0,
      selectedPlanStart: moment()
        .tz("Asia/Taipei")
        .format("YYYY-MM-DD"),
      selectedPlanEnd: moment()
        .add(1, "years")
        .tz("Asia/Taipei")
        .format("YYYY-MM-DD"),
      selectedPlan: "",
      plans: [],
      createContractSatus: false,
      contracts: [],
      data: [],
      initialized: false
    };
  },
  props: {
    accountId: {
      type: Number,
      default: 1
    }
  },
  created: function() {
    // fetch value
    console.log("created!!");
    fetchContract(this.accountId)
      .then(fetchContractRes => {
        if (fetchContractRes.data.length > 0) {
          this.setData(fetchContractRes.data);
        } else {
          this.setData([]);
        }
      })
      .catch(err => {
        console.log("err: ", err);
        this.$message({
          type: "error",
          message: `商店：${this.accountId} ，無法取得資料！`
        });
      });

    fetchSettings(this.accountId)
      .then(fetchSettingsRes => {
        if (fetchSettingsRes.data.length > 0) {
          this.setSettingData(fetchSettingsRes.data[0]);
        } else {
          throw new Error("FetchData error!");
        }
      })
      .catch(err => {
        console.log("err: ", err);
        this.$message({
          type: "error",
          message: `商店：${this.accountId} ，無法取得資料！`
        });
      });

    fetchPlans()
      .then(fetchPlansRes => {
        this.plans = fetchPlansRes.data;
        console.log("this.plans: ", this.plans);
        this.selectedPlan = fetchPlansRes.data[0].code;
      })
      .catch(fetchPlansErr => {
        this.$message({
          type: "error",
          message: `商店：${this.accountId} ，無法取得資料！`
        });
      });

    fetchShopInfoByAccountId(this.accountId)
      .then(fetchShopInfoRes => {
        console.log("fetchShopInfoRes: ", fetchShopInfoRes);
        this.businessId = fetchShopInfoRes.data.businessId;
      })
      .catch(fetchShopInfoErr => {
        this.$message({
          type: "error",
          message: `商店：${this.accountId} ，無法取得資料！`
        });
      });
  },
  mounted() {
    // 檢查是否有關聯的開店訂單資料
    // 如果有，抓出合約資訊
    this.getRegistrationOrders();
  },
  methods: {
    setSettingData(fetchData) {
      for (var prop in fetchData) {
        if (fetchData[prop] === 1) fetchData[prop] = true;
        if (fetchData[prop] === 0) fetchData[prop] = false;
      }
      console.log("fetchData: ", fetchData);
      this.settingData = Object.assign(this.settingData, fetchData);
      console.log("this.settingData: ", this.settingData);
    },
    toggleSwitch(event) {
      this.data[event.code] = event.mutation;
      this.data = Object.assign(this.data);

      let updateBooleanData = {
        key: event.code,
        value: event.mutation,
        dbTable: event.dbTable,
        label: event.name,
        type: event.type
      };
      this.edit(updateBooleanData);
    },
    edit(data) {
      console.log("something-wrong: ");
      let label = data.label;
      if (data.key === "name") data.dbTable = "accounts&business";
      switch (data.dbTable) {
        case "accounts":
          updateAccounts(data, this.accountId)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "business":
          updateBusiness(data, this.accountId)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "business_info":
          updateBusinessInfo(data, this.accountId)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "accounts&business":
          updateAccounts(data, this.accountId)
            .then(res => updateBusiness(data, this.accountId))
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "account_sso":
          let fields = Object.assign(
            {},
            {
              name: this.data.name,
              accountId: this.accountId,
              appId: data.value
            }
          );
          Object.assign(data, {
            fields: fields
          });
          console.log("data: ", data);
          updateAccountSSo(data, this.accountId)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        default:
          console.log("undefined db talbe: " + data.dbTable);
          break;
      }
    },
    editSuccess(res, label) {
      console.log(res);
      this.$message({
        type: "success",
        message: `${label} 修改成功！`
      });
      this.$emit("saved", true);
    },
    editError(err) {
      console.log(err);
      this.$message({
        type: "error",
        message: "修改失敗"
      });
    },
    displayContractStatus(contractStatus) {
      return contractStatus ? "關閉" : "啟用中";
    },
    reFetchContract() {
      fetchContract(this.accountId)
        .then(fetchContractRes => {
          if (fetchContractRes.data.length > 0) {
            this.setData(fetchContractRes.data);
          } else {
            this.setData([]);
          }
        })
        .catch(err => {
          console.log("err: ", err);
          this.$message({
            type: "error",
            message: `商店：${this.accountId} ，無法取得資料！`
          });
        });
    },
    setData(fetchData) {
      console.log("fetchData: ", fetchData);
      fetchData.forEach((data, index) => {
        this.$set(this.contracts, index, data);
      });
      console.log("this.contracts: ", this.contracts);
      this.initialized = true;
    },
    systemStart() {
      console.log("start");
      enable(this.accountId)
        .then(res => {
          // window.location.reload();
          this.reFetchContract();
        })
        .catch(err => {
          console.log("err: ", err);
        });
    },
    systemEnd() {
      console.log("stop");
      disable(this.accountId)
        .then(res => {
          // window.location.reload();
          this.reFetchContract();
        })
        .catch(err => {
          console.log("err: ", err);
        });
    },
    displayContractStart(timestamp) {
      return moment(timestamp)
        .tz("Asia/Taipei")
        .format("YYYY-MM-DD");
    },
    displayContractEnd(timestamp) {
      return moment(timestamp)
        .tz("Asia/Taipei")
        .format("YYYY-MM-DD");
    },
    displaySystemEnd(timestamp) {
      return moment(timestamp)
        .tz("Asia/Taipei")
        .format("YYYY-MM-DD");
    },
    showCreateContract() {
      this.createContractSatus = true;
      return;
    },
    hideCreateContract() {
      this.createContractSatus = false;
      return;
    },
    addContract() {
      console.log("addContract");
      // insert into contracts
      var that = this;
      let businessId = this.businessId;
      function findPlanId(planCode) {
        return that.plans.find(plan => plan.code == planCode).id;
      }

      let createContractData = {
        shopId: this.accountId,
        businessId,
        start: this.selectedPlanStart,
        end: this.selectedPlanEnd,
        sysEnd: moment(this.selectedPlanEnd)
          .add(7, "days")
          .format("YYYY-MM-DD"),
        plan: findPlanId(this.selectedPlan),
        registrationOrderId: null,
        status: "normal"
      };
      console.log("createContractData: ", createContractData);
      createContract(createContractData)
        .then(res => {
          console.log("createContract: ", res.data);
          if (res.data.insertId > 0) {
            this.reFetchContract();
            this.hideCreateContract();
            this.$message({
              type: "success",
              message: `新增合約成功！`
            });
          } else {
            this.$message({
              type: "error",
              message: `新增合約失敗！`
            });
          }
        })
        .catch(createContractErr => {
          console.log("createContractErr: ", createContractErr);
          this.$message({
            type: "error",
            message: `新增合約失敗！`
          });
        });
    },
    getRegistrationOrders() {
      // todo - 這個東西不知道誰加上去的，需要詢問程式邏輯
      let self = this;
      return axios
        .get(
          `${
            process.env.VUE_APP_APIHOST
          }/gaa/shops/${self.businessId}/registration-orders`
        )
        .then(response => {
          self.registrationOrders = response.data;
          if (self.registrationOrders) {
            for (let i = 0; i < self.registrationOrders.length; ++i) {
              if (self.registrationOrders[i].createdTs) {
                self.registrationOrders[i].createdTime = moment
                  .unix(self.registrationOrders[i].createdTs)
                  .format("YYYY-MM-DD HH:mm:ss");
              }
            }
          }
        });
    }
  },
  watch: {}
};
</script>
<style scoped src="../../../../../src/assets/css/shop-console.css"></style>
<style scoped>
.status-off {
  color: red !important;
}
.status-on {
  color: green !important;
}
</style>
